import Masonry from "masonry-layout";

$('[data-product-colors]').on('click', '.products__item-color', function (e) {
    e.preventDefault();
    const $target = $(this);
    const product_container = $target.closest('[data-item-product-id]');
    const product_id = product_container.data('item-product-id');
    const product_color = $target.data('product-color');
    const product_cart = product_container.find('[data-product-id]');
    const product_price = product_container.find('[data-item-product-price]');

    $target.siblings().removeClass('active');
    $target.addClass('active');

    const product_desired_item = $(`[data-item-hidden-product-id='${product_id}']`).find(`[data-item-hidden-variation-color='${product_color}']`);
    const product_desired_variation_id = product_desired_item.data('item-hidden-variation-id')
    const product_desired_variation_price = product_desired_item.data('item-hidden-variation-price')

    const desired_image_src = product_desired_item.find('[data-image-main] img').attr('src');
    const add_image_src = product_desired_item.find('[data-image-add] img').attr('src');

    product_container.find('[data-current-main-image]').attr('src', desired_image_src);
    product_container.find('[data-current-add-image]').attr('src', add_image_src);
    product_cart.attr('data-product-id', product_desired_variation_id)

    const product_new_link = product_container.attr('href').replace(/(?<=\attribute_pa_color=)[^&]*/, product_color);
    product_container.attr('href', product_new_link)
    product_price.text(`$${product_desired_variation_price}`)
});

$('.products__item-cart').hover(function () {
    $(this).siblings('.products__item-images').find('.products__item-image')
        .toggleClass('image--main image--add');
});


const products = document.querySelector('.products');
const products_links = products ? products.querySelectorAll('a') : null;

const few_products = products_links?.length <= 4

if (few_products && !products.classList.contains('only--category'))
    products.classList.add('few')

if (products && !products.classList.contains('only--category')) {
    if (window.innerWidth >= 1200 && window.innerWidth < 1990 && !few_products) {
        new Masonry(products, {
            itemSelector: '.products__item',
            columnWidth: getWidth()
        });

        function getWidth() {
            const windowWidth = window.innerWidth;
            const widthMap = {
                1290: 295,
                1390: 320,
                1490: 320,
                1590: 345,
                1690: 370,
                1790: 395,
                default: 437.5
            };
            for (let width in widthMap) {
                if (windowWidth <= width) {
                    return widthMap[width];
                }
            }
            return widthMap.default;
        }
    }
}
